import React from "react";
import { Box, Text, Flex } from "@chakra-ui/react";
import { Section } from "components/section";
import { TextTitle } from "ui/text";
import Link from "next/link";

export type Deparment = {
  id: number;
  name: string;
  jobs: Array<{
    id: number;
    url: string;
    title: string;
    location: string;
  }>;
};

export function JobListings({ titleId, departments }: { titleId: string; departments: Deparment[] }) {
  return (
    <Section center my="0">
      <TextTitle
        id={titleId}
        size="xl"
        align="center"
        mobileAlign="center"
        title="Open positions"
        scrollMarginTop={32}
      />

      <Flex
        direction="column"
        width="4xl"
        maxWidth="100%"
        mx="auto"
        mt={{ base: "biggest", md: "huge" }}
        gap={{ base: "bigger", md: "biggest" }}
      >
        {departments.map((department) => (
          <Box key={department.id}>
            <TextTitle size="sm" titleAs="h3" ml={{ md: "smaller" }} title={department.name} />

            <Flex
              as="ul"
              direction="column"
              listStyleType="none"
              mt={{ base: "small", md: "smaller" }}
              gap={{ base: "small", lg: "tiniest" }}
            >
              {department.jobs.map((job) => (
                <Box key={job.id} as="li">
                  <Flex
                    as={Link}
                    position="relative"
                    href={job.url}
                    target="_blank"
                    rel="noreferrer"
                    borderRadius="base"
                    direction={{ base: "column", md: "row" }}
                    align={{ base: "start", lg: "center" }}
                    justify="space-between"
                    gap="tiny"
                    px={{ md: "smaller" }}
                    py={{ md: "smallest" }}
                    textStyle="caption1"
                    transition="all .15s ease-in-out"
                    _hover={{ bgColor: { md: "brand.backgroundSecondary.light" } }}
                    _focus={{
                      outline: "none !important",
                    }}
                    _focusVisible={{
                      boxShadow: "outline",
                    }}
                  >
                    <Text fontWeight="semibold">{job.title}</Text>
                    <Text color="brand.textSecondary.light">{job.location}</Text>
                  </Flex>
                </Box>
              ))}
            </Flex>
          </Box>
        ))}
      </Flex>
    </Section>
  );
}
